import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/client/$accountId/wallets/$walletId/summary`,
      params: {
        accountId: params.accountId,
        walletId: params.walletId,
      },
      replace: true,
    });
  },
});
